import React from "react";
import { ChevronRight } from "react-feather";
import type { ConnectorActionButtonProps } from "./ConnectorActionButton.types";
import { StyledActionButton } from "./ConnectorActionButton.styles";

export const ConnectorActionButton: React.FC<ConnectorActionButtonProps> = ({
  label,
  withChevron = false,
  className,
}) => (
  <StyledActionButton className={className}>
    {label}
    {withChevron && <ChevronRight />}
  </StyledActionButton>
);

export default ConnectorActionButton;
